module.exports = __webpack_public_path__ + "img/GS1-Germany-Logo.32cb59df.png";